export const STORAGE_KEY_PREFIX = 'routable_';

export const INITIAL_ROUTE_KEY = `${STORAGE_KEY_PREFIX}initialRoute`;
